module.exports = __webpack_public_path__ + "img/university_11.cf6bdd30.png";